module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/invision-44a31bef4ab2ab9024b572b287188c43.svg";